export function getRootConfigKey(configTree) {
    for (var _i = 0, _a = Array.from(configTree.entries()); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (value.parent == null) {
            return key;
        }
    }
    throw Error('Could not find root config');
}
//# sourceMappingURL=getRootConfigKey.js.map